import { useHistory } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AdminActivityDetailSection from 'src/components/admin/AdminActivityDetailSection';
import AdminFilingDetailsSection from 'src/components/section/AdminFilingDetailsSection';
import Wrapper from 'src/components/util/Wrapper';
import { useAPI } from '../../services/api';

const AccountDetailsBody = ({
  accountNo,
  columns,
  taxYear,
  detailInfo,
  handleError,
  loginBackdoor,
  success,
  activityRows,
}) => {
  const history = useHistory();
  const api = useAPI();

  const redirectPath = '/home';
  const redirectToBackdoorPage = () => {
    history.push('/admin/home');
  };

  return (
    <>
      <Box sx={{ maxWidth: '80vw', margin: 'auto' }}>
        <Wrapper
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: { sm: 'start', md: 'center' },
            flexDirection: { sm: 'column', md: 'row' },
            mt: '2rem',
            mb: '0.5rem',
          }}
        >
          <Button variant="outlined" startIcon={<ArrowBack />} onClick={redirectToBackdoorPage}>
            Back
          </Button>
          <Button
            variant="outlined"
            startIcon={<AccountCircleIcon />}
            onClick={async () => {
              try {
                await api.get('/admin/reviewFiling', {
                  params: {
                    accountNo,
                    taxYear,
                  },
                });
                const response = await api.post('/account/accessToken', {
                  isAdmin: true,
                });

                loginBackdoor(response.headers['x-access-token'], response.data.exp);

                history.replace(redirectPath);
                success('Success');
              } catch (err) {
                handleError(err);
                console.error(err);
              }
            }}
          >
            Review Filing
          </Button>
        </Wrapper>

        {/* Acitivity Detail */}
        <AdminActivityDetailSection activityRows={activityRows} columns={columns} />

        {/* Account Detail */}
        <AdminFilingDetailsSection detailInfo={detailInfo} />
      </Box>
    </>
  );
};

export default AccountDetailsBody;
